export default __webpack_public_path__ + "backgroundBuild.ca4546e.png";